module.exports = __webpack_public_path__ + "img/13.e6ba0d55.svg";